import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex';
import axios from 'axios'
import VueAxios from "vue-axios"
import VueI18n from 'vue-i18n'
import {api} from "./api/api";
import ViewUI from 'view-design';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './my-theme/index.less';
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
import {enMessage} from './common/lang/en';
import {zhMessage} from './common/lang/zh';
import {vuexStore} from "./state";
import * as VueGoogleMaps from 'vue2-google-maps'
// 注册到Vue全局组件中
Vue.use(VueAxios, axios)
Vue.use(VueI18n)
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(ViewUI);
Vue.locale = () => {};
Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA-mjHWCH8Cql549ifmt4NzWmwXWyBPOa0', // 此处填入谷歌地图申请的key
    libraries: 'places'
  }
})
// 引入 store
export const store = new Vuex.Store(vuexStore);
// 自定义指令，实现动态展示页面标题
Vue.directive('web-title', {
  inserted(el, binding) {
    const {value} = binding;
    if (el.dataset.title) {
      document.title = el.dataset.title;
    } else if (value && value.title) {
      document.title = value.title;
    }
  },
  update(el, binding) {
    const {value} = binding;
    if (el.dataset.title) {
      document.title = el.dataset.title;
    } else if (value && value.title) {
      document.title = value.title;
    }
  }
});

const messages = {
  en: Object.assign({message: enMessage}, en),
  zh: Object.assign({message: zhMessage}, zh)
};

const i18n = new VueI18n({
  locale: 'en',
  messages
});

Vue.config.productionTip = false

// Vue.prototype._i18n = i18n;
Vue.prototype.api = api;

new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
